import './Switch.scss'
import React from 'react'
import classnames from 'classnames'
import InputWrapper from './InputWrapper'

const Switch = (props) => {
  const {
    id,
    label,
    value,
    disabled,
    className,
    onChange
  } = props
  const isChecked = !!value
  const handleChange = () => !disabled && onChange(!isChecked)
  return (
    <InputWrapper {...props} className={classnames('Switch', className)}>
      <input
        id={id}
        name={label}
        type='checkbox'
        disabled={disabled}
        checked={isChecked}
        onChange={handleChange}
      />
      <span className='Switch_toggle' onClick={handleChange} />
    </InputWrapper>
  )
}

Switch.displayName = 'Switch'

export default Switch



// WEBPACK FOOTER //
// ./src/lib/form/Switch.js